import React, { useEffect, useState } from "react";
import Property from "../components/hostComponents/Property";
import HostNav from "../components/hostComponents/HostNav";
import { useDispatch, useSelector } from "react-redux";
import { getFlags, getHostProperties } from "../store/thunks/hostActions";
import { useNavigate } from "react-router-dom";
import Banner from "../components/utilityComponents/Banner";
import { logout } from "../store/slices/hostSlices";
import { Alert, CircularProgress } from "@mui/material";
import {
  updatePropertyReset,
  deletePropertyReset,
  addPropertyReset,
} from "../store/slices/hostSlices";
import request from "../utils/request";
import onboard from "../icons/onboard.svg";
import TutorialModal from "../components/TutorialModal";
import Calendly from "./Calendly";

const HostScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [onBoardLoading, setOnBoardLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [errorOnBorad, setErrorOnBoard] = useState();
  const [tutorialStep, setTutorialStep] = useState(0);
  const [showTutorial, setShowTutorial] = useState(true);

  const handleClick = async () => {
    setOnBoardLoading(true);
    try {
      const { data } = await request.get("/stripe/get-onboarding-link");
      window.location.href = data.url;
    } catch (error) {
      setErrorOnBoard(error.response.data.msg);
    }
  };

  const { hostInfo } = useSelector((state) => state.host);
  const hostDetails = useSelector((state) => state.hostDetails.Info);
  const isOnBoarded = hostDetails?.isOnBoarded;
  const isOnboardingBooked = hostDetails?.isOnboardingBooked;
  const selfOnboarding = hostDetails?.selfOnboarding;

  const [data, setData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request.get(
          `properties/host/${hostInfo._id}/commission`
        );
        setData(response.data.commission);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    };
    dispatch(getFlags(hostInfo._id));
    dispatch(getHostProperties(hostInfo._id));
    fetchData();
  }, [hostInfo]);

  const { loading: loadingProperties, properties, error } = useSelector(
    (state) => state.hostProperties
  );

  const { success: successUpdate, message: messsageupdate } = useSelector(
    (state) => state.propertyUpdate
  );
  const { success: successDelete, message: messageDelete } = useSelector(
    (state) => state.propertyDelete
  );
  const {
    success: successAddProperty,
    msg: messageAddProperty,
    error: errorAddProperty,
  } = useSelector((state) => state.addProperty);

  useEffect(() => {
    if (successUpdate || successDelete)
      dispatch(getHostProperties(hostInfo._id));
  }, [successUpdate, successDelete]);

  useEffect(() => {
    if (successUpdate || successDelete || successAddProperty) {
      setTimeout(() => {
        successUpdate && dispatch(updatePropertyReset());
        successDelete && dispatch(deletePropertyReset());
        successAddProperty && dispatch(addPropertyReset());
      }, 2000);
    }
  }, [successAddProperty, successUpdate, successDelete, dispatch]);

  const handleNext = () => setTutorialStep((prev) => prev + 1);
  const handleBack = () => setTutorialStep((prev) => prev - 1);
  const handleClose = () => setShowTutorial(false);

  let propertyList = properties;
  if (search.length !== 0) {
    propertyList = propertyList.filter((property) =>
      `${property.address.line1} ${property.address.line2 || ""}, ${property.address.city}, ${property.address.state} ${property.address.zipCode}, United States`
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  }

  if (selfOnboarding && !isOnboardingBooked && !isOnBoarded) {
    return (
      
      <div className="flex w-full h-screen overflow-auto">
                 {showTutorial &&  (
            <TutorialModal
              step={tutorialStep}
              onNext={handleNext}
              onBack={handleBack}
              onClose={handleClose}
            />
          )}

        <div className="flex flex-col w-full px-10 tablet:px-0 mx-auto">
          <HostNav searchBar={true} setSearch={setSearch} />
          <div className="flex flex-col items-center justify-center mt-10">
            <h2 className="text-xl font-bold mb-4">Schedule Your Onboarding Call</h2>
            <Calendly />
            <p className="text-center text-sm mt-4">
              Once scheduled, our team will walk you through setup and answer any questions you have.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex w-full h-screen overflow-auto min-h-[500px]">
        <div className="flex flex-col w-full mobile:w-full px-10 tablet:px-0 mx-auto h-full">
          <HostNav searchBar={true} setSearch={setSearch} />

          {successAddProperty && <Alert severity="success">{messageAddProperty}</Alert>}
          {successUpdate && <Alert severity="success">{messsageupdate}</Alert>}
          {successDelete && <Alert severity="warning">{messageDelete}</Alert>}

          {isOnBoarded === false ? (
            <div>
              {errorOnBorad && <Alert severity="error">{errorOnBorad}</Alert>}
              <div className="flex items-center justify-center">
                <div className="flex flex-col justify-center items-center max-w-[300px]">
                  <div>
                    <img src={onboard} />
                  </div>
                  <p>Cannot Add Properties until you have set up your Stripe Account</p>
                  <button
                    onClick={handleClick}
                    className="bg-primary p-2 rounded text-white w-full my-5"
                  >
                    {onBoardLoading ? (
                      <CircularProgress color="inherit" className="mr-2" size={"20px"} />
                    ) : (
                      "Link Stripe Account"
                    )}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div
              id="host_screen_scroll"
              className="m-auto bg-transparent pb-[30px] my-7 rounded-xl w-full tablet:w-[90%] gap-x-5 overflow-scroll laptop:p-2 flex-grow"
            >
              {error && <Alert severity="error">{error}</Alert>}
              <div className="tablet:w-[95%] mx-auto pt-0">
                {loadingProperties ? (
                  <div className="flex flex-col justify-center gap-2 items-center w-full h-20 rounded-xl bg-lightgrey my-3"></div>
                ) : propertyList.length === 0 ? (
                  <div className="flex w-full min-h-[400px] flex-grow justify-center items-center">
                    <h1 className="text-base3 font-bold">
                      {search?.length > 0
                        ? "No Match Found"
                        : "Start by Adding Your First Property"}
                    </h1>
                  </div>
                ) : (
                  propertyList.map((property) => (
                    <Property
                      key={property._id}
                      property={property}
                      data={data}
                    />
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HostScreen;
